import { observer } from 'mobx-react-lite'
import { FullPageWrapper, SpinnerLoader } from 'shared/ui'
import {
  SecurityProvider,
  useSecurityContext,
} from 'pages/settings/pages/personal/pages/account/pages/security/context/securityContext'
import { SecurityPageSettings } from 'pages/settings/pages/personal/pages/account/pages/security/ui/SecurityPageSettings/SecurityPageSettings'

export const SecurityPageUi = observer(() => {
  const { initialLoading } = useSecurityContext()

  if (initialLoading) return <SpinnerLoader ariaLabel={'PersonalSecurityTab'} />

  return <SecurityPageSettings />
})

export const SecurityPage = observer(() => {
  return (
    <FullPageWrapper>
      <SecurityProvider>
        <SecurityPageUi />
      </SecurityProvider>
    </FullPageWrapper>
  )
})
